import { useCallback } from 'react';
import { useForm } from 'react-hook-form';

import * as crawlerApi from 'api/crawlerApi';
import { REGISTRATION_STEP } from 'constants/registrationStep';
import { useToast } from 'hooks/useToast';
import { useAppDispatch, useAppSelector } from 'store/hooks/useStore';
import {
  detailActions,
  detailSelectors,
} from 'store/reducers/crawlerReducer/detailSlice';
import { loaderActions } from 'store/reducers/loaderReducer/loaderSlice';
import {
  CrawlerDetailFormFields,
  createCrawlerDetailFormFields,
  mapFormFieldsToCrawlerDetailAddPayload,
} from '../types/crawlerDetailFormFields';

export const useAddDetailStore = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const selectedCrawler = useAppSelector(detailSelectors.selectedCrawler);
  const selectedCrawlerDetails = useAppSelector(
    detailSelectors.selectedCrawlerDetails,
  );
  const isOpenModal = useAppSelector(detailSelectors.isOpenModalAddDetail);
  const currentModalStep = useAppSelector(detailSelectors.currentModalStep);

  const form = useForm<CrawlerDetailFormFields>({
    defaultValues: createCrawlerDetailFormFields({}),
    mode: 'all',
  });
  const { handleSubmit, getValues, reset } = form;

  const onCloseModal = useCallback(() => {
    dispatch(detailActions.updateIsOpenModalAddDetail(false));
    dispatch(detailActions.updateStep(REGISTRATION_STEP.INPUT));
    reset();
  }, [dispatch, reset]);

  const onConfirm = () => {
    dispatch(detailActions.updateStep(REGISTRATION_STEP.CONFIRMATION));
  };

  const onGoBack = () => {
    dispatch(detailActions.updateStep(REGISTRATION_STEP.INPUT));
  };

  const onSubmit = handleSubmit(
    async (values: CrawlerDetailFormFields) => {
      if (selectedCrawler) {
        dispatch(loaderActions.setLoading(true));
        const result = await crawlerApi.addCrawlerDetail(
          selectedCrawler.id,
          mapFormFieldsToCrawlerDetailAddPayload(values),
        );
        if (result.ok) {
          dispatch(detailActions.updateStep(REGISTRATION_STEP.RESULT));

          dispatch(
            detailActions.updateSelectedDetails([
              result.value,
              ...selectedCrawlerDetails,
            ]),
          );
        } else {
          toast({
            status: 'error',
            description: 'バージョン追加に失敗しました。',
          });
        }
        dispatch(loaderActions.setLoading(false));
      }
    },
    () => {
      toast({
        status: 'error',
        description: 'バージョン追加に失敗しました。',
      });
    },
  );

  return {
    /** バージョン履歴フォーム */
    form,
    /** 入力値 */
    values: getValues(),
    /** クローラーバージョン追加モーダルを閉じる */
    onCloseModal,
    /** クローラーバージョン追加モーダルの表示状態 */
    isOpenModal,
    /** クローラーバージョン追加モーダルの現ステップ */
    currentModalStep,
    onConfirm,
    onGoBack,
    onSubmit,
  };
};
